"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PrintPicture: ['print-picture', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.75,6a1,1,0,0,0,1-1V2h8.836L17.75,4.163V5a1,1,0,0,0,2,0V3.749a1,1,0,0,0-.293-.707L17,.587A2.01,2.01,0,0,0,15.586,0H6.75a2,2,0,0,0-2,2V5A1,1,0,0,0,5.75,6Z', 'M21.5,7H2.5A2.5,2.5,0,0,0,0,9.5V14a2.5,2.5,0,0,0,2.5,2.5H5v6.25A1.251,1.251,0,0,0,6.25,24h12a1.251,1.251,0,0,0,1.25-1.25V16.5h2A2.5,2.5,0,0,0,24,14V9.5A2.5,2.5,0,0,0,21.5,7Zm-18,4.5a1,1,0,1,1,1-1A1,1,0,0,1,3.5,11.5Zm14,10a.5.5,0,0,1-.5.5H7.5a.5.5,0,0,1-.5-.5V12.457a.5.5,0,0,1,.5-.5H17a.5.5,0,0,1,.5.5Z', 'M14.686,15.894a.5.5,0,0,0-.413-.307.51.51,0,0,0-.465.219l-1.66,2.477L10.5,16.933a.5.5,0,0,0-.762.156L8.1,20.27A.5.5,0,0,0,8.542,21h7.5a.5.5,0,0,0,.462-.69Z']],
  PrintText: ['print-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.75,6a1,1,0,0,0,1-1V2h8.836L17.75,4.163V5a1,1,0,0,0,2,0V3.749a1,1,0,0,0-.293-.707L17,.587A2.01,2.01,0,0,0,15.586,0H6.75a2,2,0,0,0-2,2V5A1,1,0,0,0,5.75,6Z', 'M21.5,7H2.5A2.5,2.5,0,0,0,0,9.5V14a2.5,2.5,0,0,0,2.5,2.5H5v6.25A1.251,1.251,0,0,0,6.25,24h12a1.251,1.251,0,0,0,1.25-1.25V16.5h2A2.5,2.5,0,0,0,24,14V9.5A2.5,2.5,0,0,0,21.5,7Zm-18,4.5a1,1,0,1,1,1-1A1,1,0,0,1,3.5,11.5Zm14,10a.5.5,0,0,1-.5.5H7.5a.5.5,0,0,1-.5-.5V12.457a.5.5,0,0,1,.5-.5H17a.5.5,0,0,1,.5.5Z', 'M15,14.749H9.5a.75.75,0,1,0,0,1.5H15a.75.75,0,1,0,0-1.5Z', 'M13.25,18.249H9.5a.75.75,0,0,0,0,1.5h3.75a.75.75,0,0,0,0-1.5Z']]
};
exports["default"] = _default;